export default "__VITE_ASSET__C8pJSd7k__"